<template>
  <div class="container lexical">
        <h4 class="lexical-title">
            {{ lexical.term_english }}
        </h4>
        

        <div class="lexical-references">
            <h5>Target Language</h5>
            <div v-for="lang in apiLanguages">
                <p v-if="lang.id === lexical.lang_occu_id">
                    {{ lang.name }}
                </p>
            </div>
            <h5>Source Language</h5>
            <div v-for="lang in apiLanguages">
                <p v-if="lang.id === lexical.lang_orig_id">
                    {{ lang.name }}
                </p>
            </div>
        </div>        
        
        <div class="lexical-references">
            <h5>Grammatical category</h5>
            <div v-for="gram in apiGramCategories">
                <p v-if="gram.id === lexical.gramcategory_id">
                    {{ gram.long_name }}
                </p>
            </div>
        </div>
        <div v-if="lexical.meaning" class="lexical-references">
            <h5>Meaning</h5>
            <p v-html="lexical.meaning"></p>
        </div>
        <div v-if="lexical.synonyms" class="lexical-references">
            <h5>Synonyms</h5>
            <p v-html="lexical.synonyms"></p>
        </div>
        <div v-if="lexical.notes" class="lexical-references">
            <h5>Notes</h5>
            <p v-html="lexical.notes"></p>
        </div>
        <div v-if="lexical.references" class="lexical-references">
            <h5>Bibliographic References</h5>
            <p v-html="lexical.references"></p>
        </div>
        <div class="lexical-author">
            Contribution from {{ lexical.author_name }} {{ lexical.author_surname }} ({{ lexical.author_affiliation }})
        </div>
    </div>

</template>

<script>
export default {
data () {
    return {
        lexical: '',
        term: '',
        apiGramCategories: '',
        apiLanguages: "",
    }
},
mounted () {
    let app = this
        app.axios.get(process.env.API_BASE_URL + '/lexicalunits/' + app.$route.params.id).then((response) => {
            app.lexical = response.data
        })
        app.axios
          .get(process.env.API_BASE_URL + "/gramcategories")
          .then(response => {
            app.apiGramCategories = response.data;
          });
        app.axios.get(process.env.API_BASE_URL + "/languages").then(response => {
          app.apiLanguages = response.data;
        });

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .lexical {
      color: black;
      &-term, &-title, &-links, &-tags, &-published {
          text-align: center;
          padding: 20px 0;
      }
      &-title {
          font-size: 24px;
      }
      &-links, &-tags {
         padding: 0 0;
        span {
            display: inline-block;
            margin: 5px 15px;
            background: #fdee21;
            padding: 5px 15px;
        }   
      }
      
      &-img {
          max-height: 300px;
          width: auto;
          margin: 30px auto;
      }
      
      &-body {
          padding: 30px 0;
            &>div, p, span {
                color: black;
                text-indent: 50px;
                font-size: 12pt;              
            }          

          h6 {
              font-size: 11pt;
          }
      }
      &-references {
          padding: 30px 0;
          h5 {
             font-style: italic;
             text-decoration: underline;
          }
          p {
              font-size: 11pt;
          }
      }
  }
</style>



// WEBPACK FOOTER //
// LexicalUnit.vue?558d403e